import React from 'react';
import Header from '../navbar/Header';
import Container from '../Container';
import Content from '../Content';
import Navbar from '../navbar/Navbar';
import FormMarket from './FormMarket';


function Market(props) {
    return (
        <Container>
        <Navbar/>

        <Content>
           <Header/>
          
         <div className='container-fluid'>
            <div className='row'>
            <FormMarket/>
            </div>
         </div>
        </Content>
       

      </Container>
    );
}

export default Market;